/**
 * ImpersonationBanner
 * Shows a warning strip when the current session was created via super-admin impersonation.
 * Reads from sessionStorage so it disappears automatically on tab close.
 */
import { useEffect, useState } from 'react';
import { FiAlertOctagon, FiX } from 'react-icons/fi';

export default function ImpersonationBanner() {
  const [info, setInfo] = useState<{ email: string; tenantId: string } | null>(null);

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem('impersonation_banner');
      if (raw) setInfo(JSON.parse(raw));
    } catch {
      // ignore
    }
  }, []);

  if (!info) return null;

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-amber-500/90 text-white text-xs font-semibold shrink-0">
      <FiAlertOctagon className="w-4 h-4 shrink-0" />
      <span className="flex-1">
        Support session active — viewing as <strong>{info.email}</strong>. This session expires in 15 minutes.
      </span>
      <button
        type="button"
        className="rounded p-0.5 hover:bg-white/20 transition-colors"
        onClick={() => {
          sessionStorage.removeItem('impersonation_banner');
          setInfo(null);
        }}
        aria-label="Dismiss"
      >
        <FiX className="w-4 h-4" />
      </button>
    </div>
  );
}
